import capitalize from "./capitalize";
import filters from "./filters";
import formatCharge from "./formatCharge";
import formatFileSize from "./formatFileSize";
import formatFileType from "./formatFileType";
import formatTimeZoneOffset from "./formatTimeZoneOffset";
import orderByDocumentPosition from "./orderByDocumentPosition";
import phoneFormatter from "./formatE164Phone";

const deps = [
	filters,
	phoneFormatter,
	formatCharge,
	capitalize,
	formatFileSize,
	formatFileType,
	formatTimeZoneOffset,
	orderByDocumentPosition
];

export default angular.module("vesl.filters", deps).name;
